exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_coverImageError_3eiwnTf-NII3UXZ0W0c7cX {\n  display: inline-block;\n  padding: 8px 16px;\n  background: #f5f5f5;\n  color: #666;\n  font-family: Segoe UI, sans-serif;\n  text-align: center;\n}\n\n.IA_coverImageErrorTitle_19re7a-nXyH5QZMpYg8DjR {\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.IA_coverImageErrorMessage_l2Ur1p035cvtcKZEydina {\n  font-size: 13px;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_coverImageError": "IA_coverImageError_3eiwnTf-NII3UXZ0W0c7cX",
	"IA_coverImageErrorTitle": "IA_coverImageErrorTitle_19re7a-nXyH5QZMpYg8DjR",
	"IA_coverImageErrorMessage": "IA_coverImageErrorMessage_l2Ur1p035cvtcKZEydina"
};